import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalSitePersonalization: ExperimentalQueries['experimentalSitePersonalization'] =
	async (_, { cloudId }, { network }) => {
		try {
			const res = await network.cfetch(
				`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
				{
					method: 'GET',
				},
			);
			return await res.json();
		} catch (e) {
			// FIXME Do not replace original errors! Reducing a rich error type like
			// the ones coming from `cfetch` to a plain `Error` with a `message` only
			// is lossy. There is product-wide logic which recognizes and acts on
			// certain error types.
			throw new Error(`/personalization ${e.message}`, { cause: e });
		}
	};
